<template>
	<div class="">
<div style=" font-size: 60px;text-align: center;background: linear-gradient(to right bottom, red, blue ); height:700px;color:white">
			about
			about
			about
			about
			about
			about
		</div>
	</div>
</template>

<script>
	export default {
		name: 'homeabout',
		data() {
			return {
			}

		},
		created() {
		},
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
	
</style>
